<template>
  <div>
    <!-- <h1>Active Opportunities</h1> -->
    <!-- <div class="row">
      <div class="col-lg-6">
        <app-job-list></app-job-list>
      </div>
      <div class="col-lg-6">
        <app-post :userID="userID"></app-post>
      </div>
    </div> -->
    <div v-if="state == 'joblist'">
      <button class="mylisting-button dark-button mb-5" @click="postState()">Post Opportunity</button>
      <!-- <router-link :to="{name: 'Job Board'}" class="" style="display: block;">Job Board</router-link> -->
      <h2 class="dashboard-heading">Manage Opportunities</h2>
      <hr>
      <app-job-list :jobs="jobs" @editJob="editJob($event)"></app-job-list>
      <div class="mt-4">
        <router-link :to="{name: 'Job Board'}" class="mylisting-button dark-button">Job Board</router-link>
      </div>
    </div>
    <div v-if="state == 'post'">
      <h2 class="dashboard-heading">Post New Opportunity</h2>
      <hr>
      <p class="mt-3" style="cursor: pointer;" @click="cancelPost()">Cancel Post</p>
      <app-job-form :userID="userID" :jobID="null" @jobPosted="jobPosted()"></app-job-form>
      <!-- <button class="mylisting-button dark-button mb-5" @click="postJob()">Post Opportunity</button> -->
      <p class="mt-3" style="cursor: pointer;" @click="cancelPost()">Cancel Post</p>
    </div>
    <div v-if="state == 'edit' && jobToEdit.id">
      <h2 class="dashboard-heading">Edit - {{ jobToEdit.title }}</h2>
      <hr>
      <p class="mt-3" style="cursor: pointer;" @click="cancelEdit()">Cancel Edit</p>
      <!-- {{ jobToEdit.id }} -->
      <app-job-form :userID="userID" :jobID="jobToEdit.id" @jobUpdated="jobUpdated()"></app-job-form>
      <p class="mt-3" style="cursor: pointer;" @click="cancelEdit()">Cancel Edit</p>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  import JobList from './JobList';
  // import PostEdit from './PostEdit';
  import JobForm from './JobForm';

  export default {
    props: ['userID'],
    data() {
      return {
        state: 'joblist',
        jobToEdit: {},
        jobs: [],
      }
    },
    components: {
      appJobList: JobList,
      appJobForm: JobForm,
    },
    created() {
      this.getJobs()

      // Scroll the window back up after saving the step
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    methods: {
      getJobs() {
        axios.get('/api/jobs/?poster='.concat(this.userID))
          .then(res => {
            this.jobs = res.data
            this.jobs = this.jobs.sort((a, b) => (a.created_date < b.created_date) ? 1 : -1)

            // // Only want to show jobs where the application deadline hasn't passed
            // var futureDeadlineJobs = []
            // for (var job in this.jobs) {
            //   if ((new Date(this.jobs[job].application_deadline.concat('T00:00:00'))) >= (new Date())) {
            //     futureDeadlineJobs.push(this.jobs[job])
            //   }
            // }
            // this.jobs = futureDeadlineJobs
          })
          .catch(error => console.log(error))
      },
      postState() {
        this.state = 'post'
      },
      cancelPost() {
        this.state = 'joblist'
      },
      jobPosted() {
        this.state = 'joblist'
        this.getJobs()

        // Scroll the window back up after saving the step
        window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      },
      editJob(job) {
        console.log(job)
        this.jobToEdit = job
        this.state = 'edit'
      },
      jobUpdated() {
        this.state = 'joblist'
        this.jobToEdit = {}
        this.getJobs()

        // Scroll the window back up after saving the step
        window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      },
      cancelEdit() {
        this.state = 'joblist'
        this.jobToEdit = {}
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/employers/jobs/Jobs.vue